import { useMutation } from 'react-query';

import { setWidgetColumns as mutationFn } from 'api/endPoints/setWidgetColumns';

interface ISetWidgetColumns {
    columns: {
        columnOrder: string[];
        hiddenColumns: string[];
    };
    widgetId?: string;
}

export const useMutationSetWidgetColumns = () => {
    return useMutation<unknown, QueryError, ISetWidgetColumns>((params) => mutationFn(params));
};
